module.exports = __webpack_public_path__ + "static/media/ddl-arrow-dark.e053d849.svg";